import { FC, HTMLProps, MouseEvent, ReactNode } from "react";
import styles from "./Button.module.scss";
import { ActionPromptType } from "../../../hooks/prompts";
import { Highlightable } from "../../Highlight/Highlightable";

export interface IButtonProps extends HTMLProps<HTMLButtonElement> {
    caption: string | ReactNode;
    type?: 'green' | 'orange' | 'white';
    handler: (event: MouseEvent<HTMLButtonElement>) => void;
    actionPropmt?: ActionPromptType;
}

export const Button: FC<IButtonProps> = ({ caption, handler, type = 'green', className, actionPropmt = ActionPromptType.NONE, ...rest }) => {
    return (
        <Highlightable promptType={ actionPropmt } highlightClass={ styles.highlight } >
            <button
                className={`${className} ${styles.button} ${styles[type]}`}
                onClick={ handler }
                {...rest}
            >
                { caption }
            </button>
        </Highlightable>
    );
}